export default __webpack_public_path__ + "static/media/move.1ad221a2.svg";